class InterceptorsManage {
  constructor () {
    this.handlers = []
  }
  use (onFulField, onRejected) {
    this.handlers.push({
      onFulField,
      onRejected
    })
  }
}

export default InterceptorsManage